import { useState, useEffect } from 'react';
import HelpTicketsPanel from '@/components/admin/HelpTicketsPanel';
import { API } from '@/App';

export default function AdminTicketsPage() {
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchTickets = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${API}/admin/help-tickets`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        setTickets(await response.json());
      }
    } catch (error) {
      console.error('Error fetching tickets:', error);
    }
  };

  return <HelpTicketsPanel tickets={tickets} />;
}
